module.exports = __webpack_public_path__ + "img/WP2023-attending-1200-1200.e37d6c1a.png";